module.exports = __webpack_public_path__ + "static/serviceberry_16x20-aab0f5743b873a2fda5e0fee215ea78c.jpg";